<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>Hatalı Kayıt Yönetim</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-flex>

        <v-flex xs12 sm12>
          <v-layout row wrap class="pa-2">
            <v-flex xs12 sm4 md2>
              <tarihim
                :etiket="$t('Starting-Date')"
                :detaygizle="false"
                v-model="searchParams.Tarih1"
                v-bind:defaultvalue="'ok'"
                :rules="[(v) => !!v || $t('Please-select-a-date')]"
              >
              </tarihim>
            </v-flex>
            <v-flex xs12 sm4 md2>
              <tarihim
                :etiket="$t('Finishing-Date')"
                :detaygizle="false"
                v-model="searchParams.Tarih2"
                v-bind:defaultvalue="'ok'"
                :rules="[(v) => !!v || $t('Please-select-a-date')]"
              >
              </tarihim>
            </v-flex>
            <v-flex xs12 sm4 md2>
              <v-radio-group v-model="searchParams.Type" row>
                <v-radio label="Cari" :value="0"></v-radio>
                <v-radio label="Fatura" :value="1"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm4 md2>
              <v-btn fab small icon color="primary" @click="getList()">
                <v-icon>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="pa-2">
            <v-flex xs12 v-if="searchParams.Type == 1">
              <v-data-table
                :headers="headerFat"
                :rows-per-page-items="[20, 100]"
                :items="itemFatList"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left">
                    {{ props.item.GenelFatID }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.FaturaNo }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.SeriNo }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.Tarih | dateformat }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.CariFaturaNo }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.CariTutar | moneyformat }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.Tutar | moneyformat }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>

            <v-flex xs12 v-if="searchParams.Type == 0">
              <v-data-table
                :headers="headerCari"
                :rows-per-page-items="[20, 100]"
                :items="itemCariList"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left">
                    {{ props.item.PNR_No }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.SirketNo }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.Nereden }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.PNRTutarTL | moneyformat }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.CariTutarTL | moneyformat }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import tool from "@/components/app/coper/tools";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import helpers from "@/components/app/customcomp/helpers.js";

export default {
  data() {
    return {
      itemCariList: [],
      headerCari: [
        {
          text: "PNR No",
          align: "left",
        },
        {
          text: "Şirket No",
          align: "left",
        },
        {
          text: "Nereden",
          align: "left",
        },
        {
          text: "PNR Tutar TL",
          align: "left",
        },
        {
          text: this.$t('Current-Price') + " TL",
          align: "left",
        },
      ],
      headerFat: [
        {
          text: " Genel Fat ID",
          align: "left",
        },
        {
          text: " Fatura No",
          align: "left",
        },
        {
          text: " Seri No",
          align: "left",
        },
        {
          text: " Tarih",
          align: "left",
        },
        {
          text: "Cari Fatura No",
          align: "left",
        },
        {
          text: this.$t('Current-Price'),
          align: "left",
        },
        {
          text: "Tutar",
          align: "left",
        },
      ],
      itemFatList: [],
      searchParams: {
        Tarih1: null,
        Tarih2: null,
        Type: 0,
      },
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
    };
  },
  methods: {
    getList() {
      this.loadingvmodel = true;
      if (this.searchParams.Type == 0) {
        let params = {
          Tarih1: this.searchParams.Tarih1,
          Tarih2: this.searchParams.Tarih2,
        };

        tool.http_post(this, "HataliCariKayitlar", params).then(
          (response) => {
            if (response.body.Status == true) {
              this.itemCariList = response.body.data;
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
            }
            this.loadingvmodel = false;
          },
          (response) => {
            this.loadingvmodel = false;
          }
        );
      } else {
        let params = {
          Tarih1: this.searchParams.Tarih1,
          Tarih2: this.searchParams.Tarih2,
        };

        tool.http_post(this, "HataliFaturalar", params).then(
          (response) => {
            if (response.body.Status == true) {
              this.itemFatList = response.body.data;
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
            }
            this.loadingvmodel = false;
          },
          (response) => {
            this.loadingvmodel = false;
          }
        );
      }
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tarihim,
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
};
</script>

<style>
</style>

